import { render } from "./PickNumbers.vue?vue&type=template&id=39d23f07&scoped=true"
import script from "./PickNumbers.vue?vue&type=script&lang=js"
export * from "./PickNumbers.vue?vue&type=script&lang=js"

import "./PickNumbers.vue?vue&type=style&index=0&id=39d23f07&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.4.29_vue@3.2.13_webpack@5.92.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-39d23f07"]])

export default __exports__